import { useState } from 'react';
import { useRootSelector } from 'common/features/featuresReducer';
import { VacationModeRequestOptions, OrgOptions } from 'common/api/e-comm/options';
import { useDispatch } from 'react-redux';
import { setOrgVacationModeOptionsThunk } from 'common/features/store/duck/organization/duck';

export interface OrgOptionsWithDates
    extends Omit<OrgOptions, 'vacationModeEndDate' | 'vacationModeStartDate'> {
    vacationModeEndDate: Date | null;
    vacationModeStartDate: Date | null;
}

export const useVacationModeState = () => {
    const vacationModeState = useRootSelector((s): OrgOptionsWithDates | null => {
        const vactionModeEndDate = s.store.organization.options?.vacationModeEndDate;
        const vactionModeStartDate = s.store.organization.options?.vacationModeStartDate;

        if (s.store.organization.options && vactionModeEndDate && vactionModeStartDate) {
            const vacationModeEndDate_ = new Date(vactionModeEndDate);
            vacationModeEndDate_.setMinutes(
                vacationModeEndDate_.getMinutes() + vacationModeEndDate_.getTimezoneOffset()
            );
            const vacationModeStartDate_ = new Date(vactionModeStartDate);
            vacationModeStartDate_.setMinutes(
                vacationModeStartDate_.getMinutes() + vacationModeStartDate_.getTimezoneOffset()
            );
            return {
                ...s.store.organization.options,
                vacationModeEndDate: vacationModeEndDate_,
                vacationModeStartDate: vacationModeStartDate_,
            };
        }
        return null;
    });

    const isVacationModeScheduled =
        vacationModeState &&
        vacationModeState.vacationModeEndDate !== null &&
        vacationModeState.vacationModeStartDate !== null;

    return {
        state: vacationModeState,
        isVacationModeScheduled, // NOTE: utilize this to render the yellow warning
    };
};

export const useVacationModeUpdateCtrl = () => {
    const [error, setError] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const dispatch = useDispatch<any>();

    const updateVacationModeData = async (data: VacationModeRequestOptions) => {
        setIsUpdating(true);
        const result = await dispatch(setOrgVacationModeOptionsThunk(data));
        setIsUpdating(false);

        // CASE: result = null => API call did not fire -- missing OrgId
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
        // @ts-ignore
        if (result === null || result.error) {
            setError(true);
            // NOTE: we were not able to update
            return false;
        }
        // NOTE: successfully updated
        return true;
    };
    return {
        updateVacationModeData,
        loading: isUpdating,
        hasError: error,
    };
};
